(() => {
  const hasPlan = item => Boolean(item.hasPlan || item.selling_plan_allocation);
  const hasGift = item => Boolean(item.hasGift || item.gift_card || item.properties?.Gift);
  const grams = item => {
    for (const option of item.variant_options || []) {
      const match = String(option).match(/^(\d+(?:\.\d+)?)\s*(kg|g)$/i);
      if (match) return Number(match[1]) * (match[2].toLowerCase() === 'kg' ? 1000 : 1);
    }
    return Number(item.grams) || 0;
  };
  const ordinary = (cart, config) => cart.items.length > 0 && cart.items.every(item => config.coffeeHandles.includes(item.handle) && !hasPlan(item) && !hasGift(item));
  const tempoHandles = ['rhythm', 'tempo-three-month-prepaid', 'tempo-six-month-prepaid'];
  const isTempo = item => tempoHandles.includes(item.handle);
  const isCoffeeSubscription = (item, config) => config.coreSubscriptionHandles?.includes(item.handle) && config.coreSubscriptionPlans?.includes(String(item.planId || item.selling_plan_allocation?.selling_plan?.id));
  const discoveryCart = (cart, config) => cart.items.length > 0 && cart.items.every(item => !hasGift(item) && (isTempo(item) || config.coffeeHandles.includes(item.handle) && (!hasPlan(item) || isCoffeeSubscription(item, config))));
  const isDecaf = item => /decaf/i.test(item.handle) || isTempo(item) && (String(item.coffeeChoice || item.properties?.['Coffee choice'] || '').toLowerCase() === 'decaf' || (item.variant_options || []).some(option => /^decaf$/i.test(option)));
  const packHandles = ['manaca-brazilian-coffee-1','regional-colombia','hoyo-frio'];
  const trial = product => product?.variants.find(variant => variant.available && variant.options.includes('250g'));
  const accepted = (cart, config) => config.acceptedSelection || cart.items.some(item => item.hasDiscovery || item.properties?._typo_offer === 'fruit-led-discovery' || item.properties?._typo_selection === 'roastery-three');
  const completePack = cart => packHandles.every(handle => cart.items.some(item => item.handle === handle && grams(item) === 250));
  const packMissing = (cart, config) => {
    if (!ordinary(cart, config) || accepted(cart, config) || completePack(cart)) return [];
    if (!cart.items.every(item => packHandles.includes(item.handle) && grams(item) === 250 && item.quantity === 1) || new Set(cart.items.map(item => item.handle)).size !== cart.items.length) return [];
    const products = packHandles.map(handle => config.packProducts?.find(product => product.handle === handle));
    if (products.some(product => !product || product.requiresPlan || !trial(product))) return [];
    return products.filter(product => !cart.items.some(item => item.handle === product.handle));
  };
  const candidates = (cart, config) => {
    if (!discoveryCart(cart, config) || accepted(cart, config) || completePack(cart) || cart.items.every(isDecaf) || cart.items.reduce((total, item) => total + grams(item) * item.quantity, 0) >= 2000) return [];
    return config.products.filter(product => product.variants.length && !cart.items.some(item => item.handle === product.handle));
  };
  const shippingEligible = (cart, config, extraHandle) => config.country === 'IE' && config.currency === 'EUR' && cart.currency === 'EUR' && !cart.total_discount && ordinary(cart, config) && cart.items.every(item => config.shippingHandles.includes(item.handle)) && (!extraHandle || config.shippingHandles.includes(extraHandle));
  const fingerprint = cart => JSON.stringify({currency:cart.currency,total:cart.total_price,discount:cart.total_discount || 0,lines:cart.items.map(item=>`${item.key}:${item.quantity}`).sort()});
  const inferredGrind = cart => {
    const values=cart.items.map(item=>item.grind || item.properties?.Grind || '');
    return values.length && values.every(value=>value && value===values[0]) ? values[0] : '';
  };
  window.TypoDiscovery = {grams, candidates, shippingEligible, fingerprint, inferredGrind, packMissing};

  function pack(root, config, money) {
    const section = root.querySelector('[data-discovery-pack]');
    let missing = packMissing(config.cart, config);
    if (!section || !missing.length || !window.CommerceBag || !window.TypoShopping) return false;
    const grind = section.querySelector('[data-pack-grind]'), button = section.querySelector('[data-pack-add]'), error = section.querySelector('[data-pack-error]'), review = section.querySelector('[data-pack-review]');
    const total = products => products.reduce((sum, product) => sum + trial(product).price, 0);
    let busy = false;
    grind.value = 'Whole bean';
    const draw = () => {
      section.querySelectorAll('[data-pack-coffee]').forEach(row => {
        const product = missing.find(product => product.handle === row.dataset.packCoffee);
        row.querySelector('[data-pack-status]').textContent = product ? '- add to your selection' : '- already in your bag';
        row.querySelector('[data-pack-price]').textContent = product ? money(trial(product).price) : '';
        row.querySelector('[data-pack-single]').hidden = !product;
      });
      section.querySelector('[data-pack-label]').textContent = `Add ${missing.length === 1 ? '1 coffee' : `${missing.length} coffees`} - ${money(total(missing))}`;
    };
    draw();
    section.hidden = false;
    root.querySelector('[data-compact-discovery]').hidden = true;
    section.querySelector('[data-pack-dismiss]').addEventListener('click', () => {
      root.hidden = true;
      try {sessionStorage.setItem('typo-discovery-dismissed','yes');} catch {}
      document.querySelector('[data-drawer-checkout]')?.focus();
    });
    const addSelection = async (handle, trigger) => {
      if (busy || window.CommerceBag.busy() || !grind.value) return;
      const selection = products => handle ? products.filter(product => product.handle === handle) : products;
      if (!selection(missing).length) return;
      const chosenGrind = grind.value;
      busy = true; error.hidden = true; review.hidden = true;
      section.querySelectorAll('button,select').forEach(control => control.disabled = true);
      section.querySelector('[data-pack-label]').textContent = 'Checking your bag...';
      try {
        const result = await window.CommerceBag.add(null, trigger, {prepare:async () => {
          const response = await fetch(config.readUrl,{cache:'no-store',headers:{Accept:'application/json'},signal:AbortSignal.timeout(15000)});
          if (!response.ok) throw new Error('Your bag could not be checked. Please refresh before adding.');
          const cart = await response.json();
          if (fingerprint(cart) !== fingerprint(config.cart) || !packMissing(cart,config).length) throw new Error('Your bag changed. Refresh it before completing the discovery pack.');
          const fresh = await Promise.all(config.packProducts.map(async product => (await window.TypoShopping.loadProduct(product.url)).data));
          const updated = packMissing(cart,{...config,packProducts:fresh});
          if (!selection(updated).length) throw new Error('One of these coffees is no longer available. Please choose from the coffee collection.');
          const previousTotal = total(selection(missing));
          missing = updated; config.packProducts = fresh; draw();
          if (total(selection(missing)) !== previousTotal) throw new Error('The price has changed. Please review the new total before adding.');
          const payload = new FormData();
          selection(missing).forEach((product,index) => {
            payload.set(`items[${index}][id]`,trial(product).id);
            payload.set(`items[${index}][quantity]`,'1');
            payload.set(`items[${index}][properties][Grind]`,chosenGrind);
            if (!handle) payload.set(`items[${index}][properties][_typo_selection]`,'roastery-three');
          });
          return payload;
        }});
        if (result?.confirmed) window.TypoShopping.emit(handle ? 'discovery_pack_single_add' : 'discovery_pack_complete',{offer_id:'roastery-three',value:total(selection(missing))/100,currency:config.currency,variant_ids:selection(missing).map(product => trial(product).id)});
      } catch (failure) {
        error.textContent = failure.message; error.hidden = false; review.hidden = false; error.focus();
      } finally {
        busy = false;
        if (section.isConnected) {section.querySelectorAll('button,select').forEach(control => control.disabled = false);draw();}
      }
    };
    button.addEventListener('click', () => addSelection(null, button));
    section.querySelectorAll('[data-pack-single]').forEach(control => control.addEventListener('click', () => addSelection(control.dataset.packSingle, control)));
    return true;
  }

  function compact(root,config) {
    const section=root.querySelector('[data-compact-discovery]');
    if(!section)return;
    try {if(sessionStorage.getItem('typo-discovery-dismissed')==='yes'){root.hidden=true;return;}} catch {}
    const offers=candidates(config.cart,config), error=section.querySelector('[data-compact-error]'), review=section.querySelector('[data-compact-review]');
    if(!offers.length){root.hidden=true;return;}
    let busy=false, uncertain=false;
    const controls=()=>section.querySelectorAll('button,select');
    const message=text=>{error.textContent=text;error.hidden=false;error.focus();};
    const read=async()=>{const response=await fetch(config.readUrl,{cache:'no-store',headers:{Accept:'application/json'},signal:AbortSignal.timeout(15000)});if(!response.ok)throw new Error('Your bag could not be checked. Please refresh it before adding.');return response.json();};
    section.querySelector('[data-compact-dismiss]').addEventListener('click',()=>{root.hidden=true;try{sessionStorage.setItem('typo-discovery-dismissed','yes');}catch{}document.querySelector('[data-drawer-checkout]')?.focus();});
    section.querySelectorAll('[data-compact-offer]').forEach(row=>{
      const product=offers.find(p=>p.handle===row.dataset.compactOffer), grind=row.querySelector('select'), button=row.querySelector('button');
      if(!product){row.hidden=true;return;}
      if('IntersectionObserver' in window){const observer=new IntersectionObserver(entries=>{if(entries.some(e=>e.isIntersecting)){window.TypoShopping?.emit('cart_discovery_view',{product_id:product.id,offer_id:'fruit-led-discovery'});observer.disconnect();}},{threshold:0.5});observer.observe(row);}
      grind.value='Whole bean';
      button.addEventListener('click',async()=>{
        const drawer=window.CommerceBag;
        if(busy || uncertain || drawer?.busy())return;
        if(!grind.value){message(`Choose a grind for ${product.title}.`);grind.focus();return;}
        const offer=product.variants[0], token=crypto.randomUUID(), chosenGrind=grind.value;
        const release=drawer?.lock();
        busy=true;error.hidden=true;review.hidden=true;controls().forEach(n=>n.disabled=true);button.textContent='Adding';
        let sent=false;
        try {
          const cart=await read();
          if(fingerprint(cart)!==fingerprint(config.cart) || !candidates(cart,config).some(p=>p.id===product.id))throw new Error('Your bag changed. Refresh it before adding this coffee.');
          sent=true;
          const response=await fetch(config.addUrl,{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},signal:AbortSignal.timeout(15000),body:JSON.stringify({items:[{id:offer.id,quantity:1,properties:{Grind:chosenGrind,_typo_offer:'fruit-led-discovery',_typo_discovery:token}}]})});
          const result=await response.json().catch(()=>null);
          if(!response.ok || !result || result.status){sent=response.status>=500||!result;throw new Error(result?.description || 'This coffee could not be added. Please check your bag.');}
          await drawer.updated('Coffee added to your bag.');
          window.TypoShopping?.emit('cart_discovery_add',{product_id:product.id,variant_id:offer.id,value:offer.price/100,currency:config.currency});
        } catch(failure){
          if(sent){try{const cart=await read();if(cart.items.some(i=>i.properties?._typo_discovery===token)){await drawer.updated('Coffee added to your bag.');return;}}catch{}uncertain=true;}
          message(uncertain?'The connection was interrupted. Check your bag before adding again to avoid a duplicate.':failure.message);review.hidden=false;
        } finally {busy=false;controls().forEach(n=>n.disabled=uncertain);button.textContent='Add';release?.();if(!error.hidden&&error.isConnected)error.focus();}
      });
    });
  }

  function init(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const config = JSON.parse(root.querySelector('[data-bag-discovery-config]').textContent);
    config.cart.items.forEach((item,index)=>{item.grind=config.grinds?.[index] || '';});
    const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en-IE', {style:'currency',currency:config.currency,minimumFractionDigits:cents % 100 ? 2 : 0}).format(cents / 100);
    const banner = (root.closest('[data-cart-surface]') || document).querySelector('[data-bag-delivery-status]');
    if (banner && shippingEligible(config.cart, config)) banner.textContent = config.cart.total_price < config.threshold ? `Add ${money(config.threshold - config.cart.total_price)} for free shipping` : 'Free ROI delivery threshold reached.';
    try {if(sessionStorage.getItem('typo-discovery-dismissed')==='yes'){root.hidden=true;return;}} catch {}
    if(pack(root,config,money))return;
    if(root.querySelector('[data-compact-discovery]')){compact(root,config);return;}
    const section = root.querySelector('[data-bag-discovery]');
    if (!section) return;
    try { if (sessionStorage.getItem('typo-discovery-dismissed') === 'yes') { root.hidden = true; return; } } catch { /* The suggestion still works when optional session storage is blocked. */ }
    const choices = candidates(config.cart, config);
    if (!choices.length) { root.hidden = true; return; }
    const form = document.getElementById(config.formId);
    const picker = section.querySelector('[data-discovery-picker]');
    const variant = section.querySelector('[data-discovery-variant]');
    const grind = section.querySelector('[data-discovery-grind]');
    const add = section.querySelector('[data-discovery-add]');
    const label = section.querySelector('[data-discovery-add-label]');
    const error = section.querySelector('[data-discovery-error]');
    const review = section.querySelector('[data-discovery-review]');
    const cartForm = document.getElementById(config.cartFormId || 'CommerceCart');
    const dismiss = section.querySelector('[data-discovery-dismiss]');
    let busy = false;
    let uncertain = false;
    let selected = choices.find(product => product.url === section.querySelector('[data-discovery-title]').getAttribute('href')) || choices[0];
    const selection = () => selected.variants.find(item => String(item.id) === variant.value);
    const dirtyQuantities = () => [...cartForm.querySelectorAll('[name="updates[]"]')].some(input => input.value !== input.defaultValue);
    const fetchCart = async (url, options) => {
      const controller = new AbortController();
      const timer = setTimeout(() => controller.abort(), 15000);
      try {return await fetch(url, {...options, signal:controller.signal});}
      finally {clearTimeout(timer);}
    };
    const readCart = async () => {
      const response = await fetchCart(config.readUrl, {cache:'no-store',headers:{Accept:'application/json'}});
      if (!response.ok) throw new Error('We could not check your bag. Please review it before adding another coffee.');
      return response.json();
    };
    const draw = () => {
      const offer = selection();
      add.disabled = busy || uncertain;
      picker.disabled = busy || uncertain; variant.disabled = busy || uncertain; grind.disabled = busy || uncertain;
      dismiss.disabled = busy;
      label.textContent = busy ? 'Adding...' : uncertain ? 'Please review your bag' : offer ? `Add ${offer.title} - ${money(offer.price)}` : 'Add a discovery bag';
      section.setAttribute('aria-busy', String(busy));
      const delivery = section.querySelector('[data-discovery-delivery]');
      delivery.textContent = 'One-time purchase. Delivery confirmed at checkout.';
      if (offer && shippingEligible(config.cart, config, selected.handle) && config.cart.total_price < config.threshold) {
        const remaining = config.threshold - config.cart.total_price - offer.price;
        delivery.textContent = remaining > 0 ? `After this bag: ${money(remaining)} to the free ROI delivery threshold. Final rates at checkout.` : `This bag would take your coffee subtotal to ${money(config.cart.total_price + offer.price)}, meeting the ${money(config.threshold)} free ROI delivery threshold. Final rates at checkout.`;
      }
      section.querySelectorAll('[data-discovery-link]').forEach(link => {link.href = offer ? `${selected.url}?variant=${offer.id}` : selected.url;});
    };
    const setProduct = product => {
      selected = product;
      picker.value = product.handle;
      section.querySelector('[data-discovery-title]').textContent = product.title;
      section.querySelector('[data-discovery-notes]').textContent = product.notes;
      const photo = section.querySelector('[data-discovery-image]');
      if (photo) {
        photo.hidden = !product.image;
        if (product.image) { photo.removeAttribute('srcset'); photo.src = product.image; photo.alt = product.title; }
      }
      variant.replaceChildren(new Option('Choose size', '', true, true));
      variant.options[0].disabled = true;
      product.variants.forEach(item => variant.add(new Option(`${item.title} - ${money(item.price)}`, item.id)));
      error.hidden = true;
      draw();
    };
    picker.replaceChildren(...choices.map(product=>new Option(product.title,product.handle)));
    section.querySelector('[data-discovery-picker-wrap]').hidden = choices.length < 2;
    dismiss.hidden = false;
    dismiss.addEventListener('click',()=>{
      root.hidden = true;
      try {sessionStorage.setItem('typo-discovery-dismissed','yes');} catch {}
      (cartForm.querySelector('[name="update"]') || cartForm.querySelector('[name="checkout"]'))?.focus();
    });
    picker.addEventListener('change',()=>setProduct(choices.find(product=>product.handle === picker.value)));
    variant.addEventListener('change',draw);
    // All controls belong to the separate add form, never the main cart update form.
    form.addEventListener('submit',async event=>{
      event.preventDefault();
      const drawer = config.context === 'drawer' ? window.CommerceBag : null;
      if (busy || uncertain || drawer?.busy() || !form.reportValidity() || !selection()) return;
      if (dirtyQuantities()) {
        error.textContent = 'Please update your bag quantities before adding a discovery coffee.'; error.hidden = false; error.focus(); return;
      }
      const offer = selection();
      const selectedGrind = grind.value;
      const token = crypto.randomUUID();
      const release = drawer ? drawer.lock() : null;
      const complete = () => drawer ? drawer.updated('Coffee added to your bag.') : location.assign(config.cartUrl);
      let sent = false;
      busy = true; error.hidden = true; review.hidden = true; draw();
      try {
        const current = await readCart();
        if (fingerprint(current) !== fingerprint(config.cart) || !candidates(current,config).some(product=>product.id === selected.id)) throw new Error('Your bag has changed. Refresh it to see your current choices before adding another coffee.');
        sent = true;
        const response = await fetchCart(config.addUrl,{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:[{id:offer.id,quantity:1,properties:{Grind:selectedGrind,_typo_offer:'fruit-led-discovery',_typo_discovery:token}}]})});
        if (!response.ok) {
          sent = response.status >= 500;
          let message = 'This coffee could not be added. Please review your bag and try again.';
          const data = await response.json().catch(()=>null);
          if (typeof data?.description === 'string') message = data.description;
          throw new Error(message);
        }
        await response.json();
        await complete();
      } catch (failure) {
        if (sent) {
          try {
            const current = await readCart();
            if (current.items.some(item=>item.properties?._typo_discovery === token)) {await complete(); return;}
          } catch {}
          // Never blindly repeat a purchase after an ambiguous network response.
          uncertain = true;
        }
        busy = false; draw();
        error.textContent = uncertain ? 'The connection was interrupted. Please review your bag before adding again so you do not get a duplicate.' : failure.name === 'AbortError' ? 'Your bag took too long to respond. Please check your connection and try again.' : failure.message;
        error.hidden = false; review.hidden = false; error.focus();
      } finally {
        release?.();
        if (drawer && !error.hidden && error.isConnected) error.focus();
      }
    });
    setProduct(selected);
  }
  const start = () => document.querySelectorAll('[data-bag-discovery-root]').forEach(init);
  window.TypoDiscovery.start = start;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',start); else start();
  document.addEventListener('shopify:section:load',start);
})();
